export enum McbGridColumnType {
  NUMBER = "number",
  BOOLEAN ="boolean" ,
  STRING = "string",
  JALALIDATE = "jalaliDate",
  DATE = "date",
  MONEY = "money"
}
